import React, { useState, useEffect } from 'react';
import { getDailyEntries, getClients } from '../api/api';
import { format } from 'date-fns';

function DailyEntriesHistory({ user }) {
  const [entries, setEntries] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    client_id: '',
    start_date: '',
    end_date: ''
  });

  useEffect(() => {
    fetchData();
  }, [filters]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [entriesRes, clientsRes] = await Promise.all([
        getDailyEntries(filters),
        getClients()
      ]);
      setEntries(entriesRes.data);
      setClients(clientsRes.data);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading && entries.length === 0) {
    return <div className="container"><div className="loading">Chargement...</div></div>;
  }

  return (
    <div className="container">
      <div className="card">
        <h2>📋 Historique des saisies</h2>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', marginBottom: '2rem' }}>
          <div className="form-group">
            <label>Client</label>
            <select value={filters.client_id} onChange={(e) => setFilters({...filters, client_id: e.target.value})}>
              <option value="">Tous les clients</option>
              {clients.map(client => (
                <option key={client.id} value={client.id}>{client.name}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Date de début</label>
            <input type="date" value={filters.start_date} onChange={(e) => setFilters({...filters, start_date: e.target.value})} />
          </div>
          <div className="form-group">
            <label>Date de fin</label>
            <input type="date" value={filters.end_date} onChange={(e) => setFilters({...filters, end_date: e.target.value})} />
          </div>
        </div>

        {entries.length === 0 ? (
          <p>Aucune saisie trouvée.</p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            {entries.map(entry => (
              <div key={entry.id} style={{ marginBottom: '2rem', padding: '1.5rem', background: '#f8f9fa', borderRadius: '8px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                  <div>
                    <h3 style={{ margin: 0 }}>{format(new Date(entry.date), 'dd/MM/yyyy')} - {entry.client_name}</h3>
                    <p style={{ margin: '0.25rem 0', color: '#666' }}>
                      {user.role !== 'driver' && `${entry.firstname} ${entry.lastname} • `}
                      Mode: {entry.payment_mode === 'stop' ? 'Au stop' : 'Au colis'}
                    </p>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '0.9rem', color: '#666' }}>CA du jour</div>
                    <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#e67e22' }}>{entry.total_revenue.toFixed(2)} €</div>
                  </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', marginBottom: '1rem' }}>
                  <div style={{ background: 'white', padding: '1rem', borderRadius: '8px', textAlign: 'center' }}>
                    <div style={{ fontSize: '0.85rem', color: '#666' }}>Emport</div>
                    <div style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#27ae60' }}>{entry.total_load}</div>
                  </div>
                  <div style={{ background: 'white', padding: '1rem', borderRadius: '8px', textAlign: 'center' }}>
                    <div style={{ fontSize: '0.85rem', color: '#666' }}>Total traité</div>
                    <div style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#B8472E' }}>{entry.total_processed}</div>
                  </div>
                  <div style={{ background: 'white', padding: '1rem', borderRadius: '8px', textAlign: 'center' }}>
                    <div style={{ fontSize: '0.85rem', color: '#666' }}>Événements</div>
                    <div style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#9b59b6' }}>{entry.events?.length || 0}</div>
                  </div>
                </div>

                {entry.events && entry.events.length > 0 && (
                  <details style={{ background: 'white', padding: '1rem', borderRadius: '8px' }}>
                    <summary style={{ cursor: 'pointer', fontWeight: 'bold', marginBottom: '0.5rem' }}>Détails des événements</summary>
                    <table style={{ marginTop: '1rem' }}>
                      <thead>
                        <tr>
                          <th>Code</th>
                          <th>Libellé</th>
                          <th>Catégorie</th>
                          <th>Quantité</th>
                          <th>Tarif unitaire</th>
                          <th>Sous-total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {entry.events.map(event => (
                          <tr key={event.id}>
                            <td><strong>{event.code}</strong></td>
                            <td>{event.label}</td>
                            <td>{event.category}</td>
                            <td>{event.quantity}</td>
                            <td>{event.unit_rate.toFixed(2)} €</td>
                            <td><strong>{event.subtotal.toFixed(2)} €</strong></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </details>
                )}

                {entry.comments && (
                  <div style={{ marginTop: '1rem', padding: '1rem', background: 'white', borderRadius: '8px', fontStyle: 'italic' }}>
                    💬 {entry.comments}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default DailyEntriesHistory;
